


export  const messages = {
  en: {
    message: {
      anounces: 'Events',
      members: 'Members',
      videos: 'Video',
      contacts: 'Contacts',
      mainpage: 'Main',     
      events_new: 'NEW EVENTS',
      events_all: 'ALL EVENTS',
      videos_new: 'VIDEO',
      videos_all: 'ALL VIDEO',
      members_new: 'MUSICIANS',
      members_all: 'ALL BAND MEMBERS',
      rider_title: 'Technical rider',
      facebook_title: 'Facebook`s group',
      telegram_title: 'Telegram`s group',


      contacts_all:  [  {"name": "Myroslava Tatarchuk", "teltag": "tel:+34643594684", "tel": "+34643594684", "email": "miroslavabirdy@gmail.com", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"}, {"name": "Dmytro Nikishin", "teltag": "tel:+380634076408", "tel": "+380634076408", "email": "nikdm@ukr.net", "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"} ],

      members_list:  [  
                       {"name": "Myroslava Tatarchuk", "role": "vocal", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"},
                       {"name": "Olena Zabuga", "role": "vocal",  "link": "https://i.ibb.co/2nm6F6q/olena-3-square.jpg"},          
                       {"name": "Dmytro Nikishin", "role": "guitar",  "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"},
                       {"name": "Andrew Trushevsky", "role": "violin",  "link": "https://i.ibb.co/ZLSbgtr/trusha-4-square.jpg"},
                       {"name": "Tatiana Gerasimova", "role": "old-time bandura",  "link": "https://i.ibb.co/C83sLdn/tanja-3-square.jpg"},
                       {"name": "Oleksiy Kulenzhov", "role": "flute",  "link": "https://i.ibb.co/LhXdy7z/aleksey-2-square.png"},
                       {"name": "Pavlo Pleskach", "role": "percussion",  "link": "https://i.ibb.co/KKsSLFS/pavlo-1-square.png"},
                       {"name": "Mayina Schwartz", "role": "dumbeck",  "link": "https://i.ibb.co/1nck6Y4/maina-1-square.png"}, 
                       ],

      rider_all: [ 
{"tech": "To organize the performance please contact Myroslava Tatarchuk (organization and financial matters) and Dmytro Nikishin (technical matters)"},
{"tech": "Technical requirements:"},
{"tech": "Vocal - a vocal microphone is required for each singer, they will be 2 or 3"},
{"tech": "Violin - the ability to connect to the console into the line through their own headset microphone is required"},
{"tech": "Guitar - Connect to line through DI-Box (large jack) or microphone input (XLR) through the own preamp"},
{"tech": "Other guitar - connected to the line via DI-Box (large jack)"},
{"tech": "Old-time bandura - in-line connection via DI-Box (large jack)"},
{"tech": "Flute - must be a microphone"},
{"tech": "Percussion - must be a microphone"},
{"tech": "Drum - must be a microphone"},
{"tech": "The remaining number of musicians, who will perform at a particular event, will be determined in the course of negotiations"},
]
      
    }
  },
  // contacts = [  {"name": "Myroslava Tatarchuk", "teltag": "tel:+380664248381", "tel": "+380664248381", "email": "miroslavabirdy@gmail.com", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"}, {"name": "Dmytro Nikishin", "teltag": "tel:+380634076408", "tel": "+380634076408", "email": "nikdm@ukr.net", "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"} ],
  ua: {
    message: {
      anounces: 'Анонси',
      members: 'Музиканти',
      videos: 'Відео',
      contacts: 'Контакти',
      mainpage: 'Головна',  
      events_new: 'НАЙБЛИЖЧІ ЗАХОДИ',
      events_all: 'ПОДИВИТИСЬ ВСІ ЗАХОДИ',
      videos_new: 'ВІДЕО',
      videos_all: 'ПОДИВИТИСЬ ВСІ ВІДЕО',
      members_new: 'МУЗИКАНТИ',
      members_all: 'ВСІ УЧАСНИКИ ГУРТУ',
      rider_title: 'Як організувати виступ Зілля',
      facebook_title: 'Група у Facebook',
      telegram_title: 'Група в Telegram',
           
      
      contacts_all: [  {"name": "Мирослава Татарчук", "teltag": "tel:+34643594684", "tel": "+34643594684", "email": "miroslavabirdy@gmail.com", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"}, {"name": "Дмитро Нікішин", "teltag": "tel:+380634076408", "tel": "+380634076408", "email": "nikdm@ukr.net", "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"} ],
      
            members_list:  [  
                       {"name": "Мирослава Татарчук", "role": "спів", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"},
                       {"name": "Олена Забуга", "role": "спів",  "link": "https://i.ibb.co/2nm6F6q/olena-3-square.jpg"},          
                       {"name": "Дмитро Нікішин", "role": "гітара",  "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"},
                       {"name": "Андрій Трушевський", "role": "скрипка",  "link": "https://i.ibb.co/ZLSbgtr/trusha-4-square.jpg"},
                       {"name": "Тетяна Герасимова", "role": "старосвітська бандура",  "link": "https://i.ibb.co/C83sLdn/tanja-3-square.jpg"},
                       {"name": "Олексій Куленцов", "role": "флейта",  "link": "https://i.ibb.co/LhXdy7z/aleksey-2-square.png"},
                       {"name": "Павло Плескач", "role": "перкусія",  "link": "https://i.ibb.co/KKsSLFS/pavlo-1-square.png"},
                       {"name": "Маїна Шварц", "role": "думбек",  "link": "https://i.ibb.co/1nck6Y4/maina-1-square.png"}, 
                       ],

      rider_all: [ 
{"tech": "Для організації виступу прохання звертатись до Мирослави Татарчук (організаційні та фінансові питання) та Дмитра Нікішина (технічні питання)"},
{"tech": "Орієнтовні технічні вимоги:"},
{"tech": "Вокал — треба вокальний мікрофон кожній співачці, їх буде 2 або 3"},
{"tech": "Скрипка — потрібна можливість підключення до пульта в лінію через власний мікрофон-гарнітуру"},
{"tech": "Гітара електроакустична — підключення в лінію через DI-Box (великий джек) або через мікрофонний вхід (XLR) через власний преамп"},
{"tech": "Друга гітара — підключення в лінію через DI-Box (великий джек)"},
{"tech": "Старосвітська бандура — підключення в лінію через DI-Box (великий джек)"},
{"tech": "Флейта — має бути мікрофон"},
{"tech": "Перкусія — має бути мікрофон"},
{"tech": "Барабан — має бути мікрофон"},
{"tech": "Остаточний склад музикантів, які будуть виступати на  конкретному заході, буде визначено в ході обговорення"},
]

    }
  },
   // contacts = [  {"name": "Мирослава Татарчук", "teltag": "tel:+380664248381", "tel": "+380664248381", "email": "miroslavabirdy@gmail.com", "link": "https://i.ibb.co/qBFxn3q/mira-3.png"}, {"name": "Дмитро Нікішин", "teltag": "tel:+380634076408", "tel": "+380634076408", "email": "nikdm@ukr.net", "link": "https://i.ibb.co/GMrzxsh/dmytro-1-square.png"} ],
};


